import { ComponentsOverrides, Theme } from '@mui/material';

export const MuiAvatar: {
    styleOverrides: ComponentsOverrides<Theme>['MuiAvatar'];
} = {
    styleOverrides: {
        root: ({ theme }) => ({
            color: theme.palette.common.white,
            fontSize: '0.875rem',
            fontWeight: 500,
            width: theme.spacing(4),
            height: theme.spacing(4),
            backgroundColor: theme.palette.common.black,
            border: `1px solid ${theme.palette.common.white}`,
        }),
    },
};
